import React from "react";
import { useIntl } from "react-intl";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorPanel, { ErrorSize } from "../ErrorPanel/ErrorPanel";
import $ from "jquery";

import PropTypes from "prop-types";

export const ModalSize = {
    Big: "Big",
    Medium: "Medium",
    Small: "Small"
};

const ComponentModal = (props) => {
    const intl = useIntl();

    $(document).ready(function () {
        if (props.showModalOnInit) {
            $("#" + props.id).modal("show");
        }
        if (props.closeModal) {
            $("#" + props.id).modal("hide");
        }
    });

    let modalSizeClasses = "";
    if (props.size === ModalSize.Big) {
        modalSizeClasses = "modal-confirm-wide";
    } else if (props.size === ModalSize.Medium) {
        modalSizeClasses = "modal-confirm-medium";
    }

    const secondButtonLabel = props.secondButtonLabel || intl.messages.cancel;
    const firstButtonLabel = props.firstButtonLabel || intl.messages.ok;
    return (
        <div id={props.id} className="modal fade">
            <div id="componentModalDialog" className={"modal-dialog modal-confirm modal-dialog-centered " + modalSizeClasses}>
                <div className="modal-content">
                    <div className="modal-header flex-column">
                        {props.icon &&
                            <div className={"icon-box " + props.iconColor}>
                                <FontAwesomeIcon icon={props.icon} />
                            </div>
                        }
                        <h4 className={"modal-title w-100 " + props.titleColor}>{props.title}</h4>
                        <button id="componentModalDismissButton" type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={props.onClose}>&times;</button>
                    </div>
                    <div className="modal-body text-left">{props.children}</div>

                    {props.hasFooter && <div id="componentModalFooter" className="modal-footer justify-content-center">
                        {props.showSecondButton &&
                            <button id="componentModalSecondButton" type="button" className="btn btn-secondary" data-dismiss="modal" onClick={props.onSecondButtonClick}>{secondButtonLabel}</button>
                        }
                        {props.showFirstButton &&
                            <button id="componentModalFirstButton" type="button" className="btn btn-primary" data-dismiss={props.disableDismiss ? false : "modal"} onClick={props.onClick} disabled={props.disableFirstButton}>{firstButtonLabel}</button>
                        }
                        {props.errorMessage &&
                            <div className="col-10 float-right">
                                <ErrorPanel size={ErrorSize.Small} >{props.errorMessage}</ErrorPanel>
                            </div>
                        }
                        {props.footer &&
                            <div className="w-100">{props.footer}</div>
                        }
                    </div>
                    }
                </div>
            </div>
        </div>
    );
}

ComponentModal.defaultProps = {
    showFirstButton: true,
    showSecondButton: false,
    disableFirstButton: false,
    showModalOnInit: false,
    disableDismiss: false,
    errorMessage: "",
    size: ModalSize.Small,
    iconColor: "",
    titleColor: "",
    closeModal: false,
    hasFooter: true
}

ComponentModal.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string,
    firstButtonLabel: PropTypes.string,
    secondButtonLabel: PropTypes.string,
    showFirstButton: PropTypes.bool,
    showSecondButton: PropTypes.bool,
    disableFirstButton: PropTypes.bool,
    icon: PropTypes.object,
    onClick: PropTypes.func,
    onSecondButtonClick: PropTypes.func,
    onClose: PropTypes.func,
    showModalOnInit: PropTypes.bool,
    disableDismiss: PropTypes.bool,
    errorMessage: PropTypes.string,
    size: PropTypes.oneOf(Object.keys(ModalSize)),
    iconColor: PropTypes.string,
    titleColor: PropTypes.string,
    closeModal: PropTypes.bool,
    hasFooter: PropTypes.bool,
    footer: PropTypes.object
};

export default ComponentModal;